<template lang="html">
  <section class="popup language">
    <div class="popup-wrapper">

      <div class="popup-header">
         Célnyelvek kiválasztása (több kiválasztható)
      </div>
      <div class="popup-container">
        <div class="popup-icons">
          <div class="ico" v-for="(data,key) in options" v-bind:key="key" :value="key">
            <input
              class="hidden"
              type="checkbox"
              v-model="languages"
              name="lang-popup-selector"
              :value="data"
              :id="'lang-popup-val-'+key"
            />
            <label :for="'lang-popup-val-'+key">
              {{data['label']}}
            </label>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <button
          type="button"
          @click="close()"
        >
          Jóváhagyás
        </button>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'LanguagePopup',
  data: function(){
    return {
      'langs$': [],
    }
  },
  props: [
    'options',
    'show',
    'lang'
  ],
  computed: {
    languages: {
      set(val) {
        this.langs$ = val
        this.$emit('update:lang', this.langs$)
      },
      get() {
        return this.lang
      }
    },
    customDoctypeEnabled() {
      return this.customDoctypeIsEnabled(this.docType$)
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    customDoctypeIsEnabled(val) {
      return val == 'mas_irat' || val == "egyeb_cegjegyzekbe_bejegyzendo_irat"
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/sass/_variables';
.popup.language{
  display: flex;
  position: fixed;
  align-content: center;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background: rgba(255,255,255,0.65);
  width: 100%;
  min-height: 100vh;
  z-index: 99;
  .popup-wrapper{
    width: 500px;
    background: white;
    box-shadow: 5px 5px 25px rgba(0,0,0,.4);
    border-radius: 5px;
    overflow: hidden;
    padding-bottom: 5px;
  }
  .popup-header, .popup-container{
    padding: .5em 1em;
  }
  .popup-header{
    font-size: 1.2em;
  }
  .popup-container{
    font-size: 1.15em;
    padding-top: 15px;
    .popup-icons{
      display: flex;
      flex: 1 1 0px;
      width: 100%;
      flex-wrap: wrap;
      justify-content: left;
      .ico{
        background: gray;
        margin-left: 5px;
        margin-bottom: 5px;
        label{
          border: 1px solid #ddd;
          background-color: #f7f7f7;
          padding: 2px 10px;
          margin: 0;
          font-weight: normal;
          font-size: 14px;
        }
        input[type="checkbox"]:checked+label {
          background-color: $selected-box-bg-color;
          border-color: $selected-box-border-color;
        }
      }
    }
  }
  .popup-footer{
    margin-top: 2em;
    padding: .5em .8em;
    text-align: right;
    button{
      background: $primary-color;
      height: 40px;
      line-height: 40px;
      text-transform: capitalize;
    }
  }
}
</style>
